exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".collapsible-body a#op-fiche{background-color:#5698d2;color:#fff;font-weight:700;width:190px;margin:15px 0;padding-left:15px}.bottom-op{display:flex;flex-wrap:wrap;flex-direction:row}.bottom-op .bottle,.bottom-op .delete,.bottom-op .refrigerant{margin:0 5px 5px 0}@media (max-width:530px){.bottom-op .bottle,.bottom-op .delete,.bottom-op .refrigerant{flex-basis:content}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a1a594f","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/fiches/bsdd/subcomponents/ManipFluide.vue
// module id = 631
// module chunks = 0